/**
 * AIエージェント向けコマンドインターフェース - 公開API
 */

// 型定義
export type {
  CommandResult,
  CommandError,
  CommandParameter,
  CommandParameterType,
  CommandCategory,
  CommandHandler,
  ParsedCommand,
  ParseResult,
  CommandContext
} from './types';

// パーサー
export { isCommandMode, parseCommand } from './CommandParser';

// レジストリ
export { commandRegistry } from './CommandRegistry';

// 実行
export { executeCommand } from './CommandExecutor';

// ハンドラ登録
export { registerAllHandlers } from './handlers';

// 初期化関数（アプリ起動時に呼び出す）
import { registerAllHandlers } from './handlers';

let initialized = false;

export function initializeCommandSystem(): void {
  if (initialized) return;
  registerAllHandlers();
  initialized = true;
}
